import React, { useRef } from 'react';
import classNames from 'classnames';
import ActionBar from '../../../../components/ActionBar';
import FilterContextProvider from '../../../../components/Filter/FilterContextProvider';
import {
  FILTER_DATA_LIST_CLASS_PREFIX,
  FilterBar,
} from '../../../../components/Filter/FilterBar';
import ProjectAdminExtensionSettingsPageTable, {
  ProjectAdminExtensionSettingsPageTableRef,
} from './ProjectAdminExtensionSettingsPageTable';
import { makePrioStyles } from '../../../../theme/utils';

const useStyles = makePrioStyles((theme) => ({
  root: { padding: 24, display: 'flex', flexDirection: 'column' },
  filterBar: { padding: theme.spacing.regular },
}));

interface ProjectAdminExtensionSettingsProps {
  className?: string;
}

export const ProjectAdminExtensionSettings: React.FC<
  ProjectAdminExtensionSettingsProps
> = (props) => {
  //#region ------------------------------ Defaults
  const { className } = props;
  const classes = useStyles();
  const tableRef = useRef<ProjectAdminExtensionSettingsPageTableRef>(null);
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  //#endregion

  //#region ------------------------------ Methods / Handlers
  //#endregion

  //#region ------------------------------ Effects
  //#endregion

  return (
    <div className={classNames(classes.root, className)}>
      <ActionBar></ActionBar>
      <FilterContextProvider searchType="projectExtensions">
        <FilterBar className={classes.filterBar} />
        <ProjectAdminExtensionSettingsPageTable
          className={FILTER_DATA_LIST_CLASS_PREFIX}
          ref={tableRef}
          tableId={'pas122'}
        />
      </FilterContextProvider>
    </div>
  );
};

export default ProjectAdminExtensionSettings;
